import { ReactNode } from 'react';
import clsx from 'clsx';
import parse from 'html-react-parser';

import Button from '$app-web/ui-kit/components/button';
import ButtonBase from '$app-web/ui-kit/components/button-base';
import Icon from '$app-web/ui-kit/components/icon';

import classes from './styles.module.scss';

interface Props {
    title?: string;
    type?: 'info' | 'error' | 'warning';
    variant?: 'filled' | 'inline';
    action?: {
        title: string;
        onClick: () => void;
        disabled?: boolean;
    };
    content?: ReactNode;
    disabledCloseAction?: boolean;
    onClose?: () => void;
}

const Alert = ({ action, content, onClose, title, type = 'info', variant = 'filled', disabledCloseAction = false }: Props) => {
    let color = 'space-500';
    let icon;
    let iconColor;

    switch (type) {
        case 'error': {
            color = 'snow-50';
            // TODO: Update this icon to use "hexagon-exclamation" (according to design) when we updated FontAwesome to v6.
            icon = ['fas', 'exclamation-square'];
            iconColor = variant === 'filled' ? 'snow-50' : 'error';
            break;
        }
        case 'warning': {
            icon = ['fas', 'exclamation-triangle'];
            iconColor = variant === 'filled' ? 'space-500' : 'warning';
            break;
        }
        default: {
            icon = ['fas', 'info-circle'];
            iconColor = variant === 'filled' ? 'ocean-400' : 'ocean-400';
            break;
        }
    }

    return (
        <div className={clsx(classes.root, classes[type], classes[variant])}>
            <div className="flex nowrap">
                <div className={clsx('item', classes.icon)}>
                    <Icon color={iconColor} fixedWidth={false} icon={icon} />
                </div>
                <div className={clsx('item xs-fill', classes.content)}>
                    {title && <div className={classes.title}>{title}</div>}
                    {content && <div className={classes.body}>{typeof content === 'string' ? parse(content) : content}</div>}
                </div>
                {onClose && (
                    <div className={clsx('item', classes.closeButtonWrapper)}>
                        {/* TODO: Replace with IconButton when it's updated to support color customization and circle shape */}
                        <ButtonBase className={classes.closeButton} {...(!disabledCloseAction && { onClick: onClose })}>
                            <Icon color={color} icon={['fal', 'times']} />
                        </ButtonBase>
                    </div>
                )}
            </div>
            {action && (
                <div className={classes.action}>
                    <div className="item">
                        <Button
                            color={type === 'info' ? 'default' : `${type}-light`}
                            disabled={action.disabled}
                            label={action.title}
                            onClick={action.onClick}
                            small
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Alert;
